<template>
  <div class="header">
    <b-modal
        no-close-on-backdrop
        title="Privacy Policy"
        class="modal-info"
        v-model="showPrivacy"
        @ok="pok()"
        ok-variant="info"
        :ok-only="true"
        ok-title="Close"
        size="xl" 
    >
        <ShowPrivacy />
    </b-modal>
    <b-modal
        no-close-on-backdrop
        title="News 2024"
        class="modal-info"
        v-model="showNews2024"
        @ok="nok()"
        ok-variant="info"
        :ok-only="true"
        ok-title="Close"
        size="xl" 
    >
        <ShowNews2024 />
    </b-modal>
    <b-modal v-model="alertsShow" size="xl" title="Alerts" class="modal-alerts" :ok-only="true" ok-title="Close">
      {{refresh}}
      <b-table striped hover :items="tblAlerts" :fields="fields" :key="refresh">
        <template #cell(setViewed)="data">
          <b-button v-if="!data.item.viewed && !$store.getters.ro" @click="setViewed(data.item.setViewed)" class="vmb"><v-icon name="camera"/></b-button>
        </template>
        <template #cell(delete)="data">
          <b-button v-if="!$store.getters.ro" @click="setDeleted(data.item.delete)" class="vmb"><v-icon name="trash"/></b-button>
        </template>
        <template #cell(message)="data">
          <span v-html="data.item.message"></span>
        </template>
      </b-table>
    </b-modal>
    <span class=fsb><span>My.</span>MARSILLI<span class=c20>2.0</span></span>
    <!-- <span class=fsb><img width=226px src="images/my.marsilli_2.0_logo.png"></span> -->
    <span class=sc>Service care {{txtfor}}</span>
    <span class=sc>{{azienda}}</span>
    <span class=privacyicon @click="showPrivacy=true">
      <v-icon name="privacy" scale="2" />
    </span>
    <!-- <span class=user @click__="gotoLogin()"> -->
      <!-- <v-icon name="regular/user-circle" scale="2" /> -->
      <button @click="gotoLogin()" type="submit" class="btn user login btn-primary">{{!logged ? 'Login' : 'Logout'}}</button>
    <!-- </span> -->
    <b-button v-if="!logged && $route.path!='/rld'" @click="reqLoginData()" type="submit" variant="primary" class="rld">Request login data</b-button>
    <span class=notif v-if="logged" @click="viewAlerts">
      <v-icon name="regular/bell" scale="2" />
      <b-badge pill variant="danger">{{numAlerts}}</b-badge>
    </span>
    <span class=user>{{user}}</span>
    <span class="user" v-if="logins && logins.length>1">
        <b-dropdown id="dropdown-logins" :text="login" variant="primary">
            <b-dropdown-item v-for="l in logins" :key="l" @click="switchUser(l)">{{l}}</b-dropdown-item>
        </b-dropdown>
    </span>
  </div>
</template>
<script>
import { API } from "@/api.js";
import ShowPrivacy from '@/views/ShowPrivacy.vue'
import ShowNews2024 from '@/views/ShowNews2024.vue'

export default {
  name: 'Header',
  data: () => ({
    alerts: [],
    alertsShow: false,
    refresh: 1,
    showPrivacy: false,
    showNews2024: false,
  }),
  components: {
    ShowPrivacy,
    ShowNews2024,
  },
  computed: {
    logins(){
        return this.$store.getters.logins
    },
    login(){
        return this.$store.getters.login
    },
    prelogged(){
        return this.$store.getters.prelogged
    },
    privacyOK(){
        return this.$store.getters.privacyOK
    },
    user(){
        return (this.$store.getters.name || "") + " " + (this.$store.getters.surname || "")
    },
    azienda(){
        if(this.$store.getters.client)
            return this.$store.getters.client
        else
            return ""
    },
    txtfor(){
        if(this.$store.getters.client)
            return "for "
        else
            return ""
    },
    fields(){
      return ["created", "type", "subject", "message", "setViewed", "delete"]
    },
    tblAlerts(){
      return this.alerts.map(a => ({created: this.$luxon(a.created), type: a.descr, subject: a.subject, message: a.message, setViewed: a.id, delete: a.id, viewed: a.viewed}))
    },
    logged(){
      console.log("logged app",this.$store.getters.userId)
      return !!this.$store.getters.userId
    },
    numAlerts(){
      return this.alerts.filter(a => !a.viewed).length
    }
  },
  async mounted () {
    setInterval( async () => {
      this.checkAlerts()
    },60000) // ogni minuto controlla
    this.checkAlerts()
    console.log("mounted",this.privacyOK,this.logged,this.prelogged)
    // dopo un refresh lo store non è ancora inizializzato: aspetto 2 secondi a fare la verifica
    setTimeout(() => {
        this.showPrivacy = !this.privacyOK && this.logged && !this.prelogged
    },2000)
    // verifico se c'è il cookie "NEWS24"
    let news24 = localStorage.getItem("NEWS24")
    console.log("news24",news24)
    this.showNews2024 = !news24
  },
  watch: {
    logged(){
        this.showPrivacy = !this.privacyOK && this.logged && !this.prelogged
        console.log("logged",this.privacyOK,this.logged,this.prelogged)
    },
    prelogged(){
        this.showPrivacy = !this.privacyOK && this.logged && !this.prelogged
        console.log("prelogged",this.privacyOK,this.logged,this.prelogged)
    },
  },
  methods: {
    async switchUser(l){
        let password = localStorage.getItem("password");
        let user = await API.login(l, password,[]);
        this.$store.commit("login", user);
        this.$store.commit("prelogged", false);
        this.$forceUpdate();
        this.$router.push("Machines");
        location.reload();
    },
    pok(){
        this.showPrivacy = false
        if(this.privacyOK)
            this.$router.push("Machines");
    },
    nok(){
        this.showNews2024 = false
        localStorage.setItem("NEWS24",true)
        this.$router.push("Machines");
    },
    reqLoginData(){
        this.$router.push({name:"RequestLoginData"});
    },
    setViewed(id){
      console.log("IDview",id)
      API.setAlert(id,true)
      let i = this.alerts.findIndex(a => a.id == id)
      let alert = this.alerts.splice(i,1)[0]
      alert.viewed = true
      this.alerts.push(alert)
      this.alerts = this.alerts.map(x => x)
      this.refresh++
    },
    setDeleted(id){
      console.log("IDdel",id)
      API.setAlert(id,false)
      let i = this.alerts.findIndex(a => a.id == id)
      console.log("i",i)
      this.alerts.splice(i,1)
      this.alerts = this.alerts.map(x => x)
      this.refresh++
      console.log("alerts",this.alerts)
    },
    async checkAlerts(){
      if(this.$store.getters.logged) {
        let data = await API.getAlerts()
        this.alerts = data
      }
    },
    viewAlerts(){
      console.log("viewAlerts !!!")
      this.alertsShow = true
    },
    gotoLogin(){
      console.log("gotlogin")
      this.$router.push('Login')
    }
  },
}
</script>
<style scoped>
button.vmb {
  fill: white;
}
.header {
  height: 4vh; /* 36px */
  max-height: 4vh; /* 36px */
}
.sc {
  /* margin-left: 10px; */
  font-weight: bolder;
  position: relative;
  top: 10px;
}
.user {
  float: right;
  margin-right: 50px;
  /* color: lightgrey; */
  fill: lightgrey;
  cursor: pointer;
  font-weight: bolder;
  position: relative;
  top: 10px;
}
.privacyicon {
  float: right;
  margin-right: 25px;
  /* color: lightgrey; */
  fill: lightgrey;
  cursor: pointer;
  font-weight: bolder;
  position: relative;
  top: 10px;
}
.notif {
  float: right;
  margin-right: 10px;
  /* color: lightgrey; */
  fill: lightgrey;
  cursor: pointer;
  position: relative;
  top: 10px;
}
span.c20 {
    font-size: 13px;
    background-color: gray;
    color: white !important;
    font-weight: 900;
    padding: 2px;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 6px;
    margin-left: 8px;
    position: relative;
    top: -6px;    
}
span.badge {
  position: relative;
  top: -7px;
  left: -12px;  
}
span.fsb {
    float: left;
    position: relative;
    top: 40px;
    left: 40px;
    font-size: xx-large;
}
span.fsb span{
    color: black;
    font-family: 'FuturaStandardLight';
}
.rld {
    background-color: #9a240d;
    border-color: #9a240d;
    position: absolute;
    top: 60px;
    right: 50px;
}
.login {
    background-color: #9a240d;
    border-color: #9a240d;
}
</style>
<style>
#dropdown-logins button {
    background-color: #9a240d;
    border-color: #9a240d;
}
</style>
